define('home/templates/channelCardCreate',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a class=\"spacing-right align__item\" href=\"/by/"
    + alias2(alias1((depth0 != null ? depth0.username : depth0), depth0))
    + "/\" data-link-name=\"user_avatar\">\n<img\nclass=\"img-round-sm block__item\"\nsrc=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.avatar : depth0)) != null ? stack1.cache : stack1), depth0))
    + "\"\nalt=\""
    + ((stack1 = container.invokePartial(partials.userNameNoLink,depth0,{"name":"userNameNoLink","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\" />\n</a>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.cardReasonForum,depth0,{"name":"cardReasonForum","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div data-role=\"card-alert\"></div>\n<div class=\"card__inner\">\n<div class=\"card__header -feed\">\n<div class=\"card__reason link-inner-gray-dark align align--middle\">\n"
    + ((stack1 = helpers["with"].call(alias1,(depth0 != null ? depth0.firstActor : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"align__item\">\n"
    + alias2(helpers.gettext.call(alias1,"%(user)s started a discussion",{"name":"gettext","hash":{"user":helpers.getPartial.call(alias1,"userGroupNames",{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\n<time class=\"bullet text-gray\">"
    + alias2(container.lambda((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</time>\n"
    + ((stack1 = container.invokePartial(partials.badges,depth0,{"name":"badges","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</div>\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.isChannelFeed : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = container.invokePartial(partials.channelCardMenu,depth0,{"name":"channelCardMenu","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = container.invokePartial(partials.channelCardContent,depth0,{"name":"channelCardContent","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true})

});
